import { render, staticRenderFns } from "./PrivacyConsent.vue?vue&type=template&id=a6690236&scoped=true&"
import script from "./PrivacyConsent.vue?vue&type=script&lang=js&"
export * from "./PrivacyConsent.vue?vue&type=script&lang=js&"
import style0 from "./PrivacyConsent.vue?vue&type=style&index=0&id=a6690236&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a6690236",
  null
  
)

export default component.exports